"use strict";

module.exports = function (column) {

  if (!this.opts.orderBy) {
    this.orderBy.column = column;
    return;
  }

  this.orderBy.column = this.opts.orderBy.column;
  this.orderBy.ascending = this.opts.orderBy.ascending;
};


//////////////////
// WEBPACK FOOTER
// ./~/vue-tables-2/compiled/methods/init-order-by.js
// module id = 2194
// module chunks = 1